import styled from '@emotion/styled';
import * as c from '@identity/constants';

export const FooterContainer = styled.ul`
  position: relative;
  display: flex;
  flex: 1 1 auto;
  justify-content: space-between;
  align-items: flex-end;
  width: 175px;
  margin: 0 auto;
  padding-bottom: 20px;
  z-index: 100000;
  color: white;
`;

export const IconContainer = styled.a`
  svg {
    height: 30px;
    width: 30px;
  }
  & path {
    transition: fill 250ms ease-in-out;
  }
  :hover {
    & path {
      fill: ${c.colors.PRIMARY_001};
    }
  }
`;
